export default __webpack_public_path__ + "static/media/cards.183c2a44.svg";